export type { BulkCollabProfileLinkRequest, BulkCollabProfileLinkResult, CollabProfileLinkRequest } from "~vue/api/generated/collab-profiles";
export type { ProfileLinkSuggestion, ProfileLinkSuggestionsResponse } from "~vue/api/generated/connections";

/** Mirrors MAX_SUGGESTIONS in coach_api/connections/profile_link_suggestions_service.py. */
export const MAX_SUGGESTIONS = 5;

export interface OwnProfileShare {
    profile_id: string;
    access: string;
    profile_url: string;
    can_share: boolean;
}

export type SuggestionStatus = "idle" | "linked" | "shared";

export type ShareTarget = "teams" | "link";

export type ShareFailureReason = "not_publishable" | "invite" | "clipboard";
